/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * regel-vrij.ts
 * Gegenereerd met Junie (AI), 06-10-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Subclass voor vrije regels met optionele payload.
 */

import { Filtertoolregel } from '../filtertool-regels';

/**
 * Vrije regel met optionele payload.
 */
export class FiltertoolVrijregel extends Filtertoolregel {
  /** Extra data voor vrije regels. */
  payload?: Record<string, any>;
  constructor(init?: Partial<Filtertoolregel> & { payload?: Record<string, any> }) {
    super('vrij', init as any);
    this.payload = init?.payload ?? {};
  }
  /**
   * Serialiseer inclusief payload.
   */
  override toObject(): any { return { ...super.toObject(), payload: this.payload ?? {} }; }
}
